import { ETourId, type ITourConfig } from '../types';

/**
 * Tour shown on the Performance Dashboard page.
 *
 * Three steps:
 * 1. See value at a glance — the ROI / value insights section
 * 2. Monitor usage — the usage chart card
 * 3. Completion performance — the completion chart card
 */
export const performanceDashboardTour: ITourConfig = {
  id: ETourId.PERFORMANCE_DASHBOARD,
  steps: [
    {
      id: 'performance-value-insights',
      target: '[data-tour-id="performance-value-insights"]',
      titleKey: 'tours.performanceDashboard.valueInsights.title',
      descriptionKey: 'tours.performanceDashboard.valueInsights.description',
      position: 'bottomLeft',
    },
    {
      id: 'performance-usage',
      target: '[data-tour-id="performance-usage-card"]',
      titleKey: 'tours.performanceDashboard.usage.title',
      descriptionKey: 'tours.performanceDashboard.usage.description',
      position: 'topLeft',
    },
    {
      id: 'performance-completion',
      target: '[data-tour-id="performance-completion-card"]',
      titleKey: 'tours.performanceDashboard.completion.title',
      descriptionKey: 'tours.performanceDashboard.completion.description',
      finishLabelKey: 'tours.performanceDashboard.completion.finishLabel',
      position: 'topLeft',
    },
  ],
  namespace: 'tours',
  variant: 'default',
  size: 'sm',
  analytics: {
    enabled: true,
    eventPrefix: 'tour_performance_dashboard',
    metadata: {
      tourName: 'Performance Dashboard',
    },
  },
  persistence: {
    strategy: 'localStorage',
  },
};
